import { render, staticRenderFns } from "./newRegisterSchool.vue?vue&type=template&id=8da143f0&"
import script from "./newRegisterSchool.js?vue&type=script&lang=js&"
export * from "./newRegisterSchool.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports